<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>This book is dedicated to the memory of <span style="font-style: normal;">DOUGLAS MITCHELL</span>, much beloved and admired longtime sociology editor at the University of Chicago Press, who had an eye for good thinking and good writing.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-becker-0006.vue?09c889bc